import React from 'react'

const doc = {
  title: 'Test Doc Title 2',
  slug: 'test-doc-2',
  tags: ['testing', '2', 'temp'],
  category: 'misc',
  content: (props) => {
      return <div>
      <p>will this work again?</p>
    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/test2.js